<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
>

<section class="jobs-section">
  <div class="container">
    <h2 class="section-title">Postes disponibles</h2>
    
    <div class="jobs-grid">
      <div class="job-card" *ngFor="let job of jobOffers">
        <div class="job-icon">
          <i class="pi pi-briefcase"></i>
        </div>
        <h3 class="job-title">{{ job.title }}</h3>
        <p class="job-description">{{ job.description }}</p>
        <a [routerLink]="job.link" class="btn-apply">
          Postuler <i class="pi pi-arrow-right"></i>
        </a>
      </div>
    </div>

    <div class="candidature-spontanee">
      <h3>Vous ne trouvez pas de poste correspondant ?</h3>
      <p>Envoyez-nous une candidature spontanée à <a href="mailto:recrutement@brokins.fr" class="email-link">recrutement&#64;brokins.fr</a></p>
    </div>
  </div>
</section>

</app-page-layout>
